import React from "react";
import ApiService from "../../../services/ApiService";
import AddCircleOutlineOutlinedIcon from "@mui/icons-material/AddCircleOutlineOutlined";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import AccordionOperations from "../../../components/Operations/AccordionOperations";
import OperationModalRegisterOrUpdate from "../../../components/Operations/OperationModalRegisterOrUpdate";
import { Spinner, Dropdown, Alert, Card } from "react-bootstrap";
import Select from "react-select";
import { store } from "../../../reducer/Store";
const OperationsTrade = () => {
  const { dispatch, state } = React.useContext(store);
  const [showAddOperation, setShowAddOperation] = React.useState(false);
  const [showUpdateOperation, setShowUpdateOperation] = React.useState(false);
  const [commentOperation, setCommentOperation] = React.useState("");

  const [animationsOperation, setAnimationsOperation] = React.useState("");

  const [descriptionOtherOffer, setDescriptionOtherOffer] = React.useState("");
  const [selectOperation, setSelectOperation] = React.useState("");
  const [selectOffre, setSelectOffre] = React.useState("");
  const [selectPrestataire, setSelectPrestataire] = React.useState("");
  const allMonth = state.allMonth;
  const [filterMonth, setFilterMonth] = React.useState(allMonth[0]);
  const [monthOne, setMonthOne] = React.useState("");
  const [monthTwo, setMonthTwo] = React.useState("");
  const [monthThree, setMonthThree] = React.useState("");
  const [operationId, setOperationId] = React.useState("");
  const [isCheckedComTool, setCheckedComTool] = React.useState();
  const [isCheckedMerchandising, setCheckedMerchandising] = React.useState();
  const [operationCommunicationToolsData, setOperationCommunicationToolsData] =
    React.useState([]);
  const [operationMerchandisingData, setOperationMerchandisingData] =
    React.useState([]);
  const [errorMessageMonths, setErrorMessageMonths] = React.useState("");

  const handleShowAdd = () => setShowAddOperation(true);

  /**
   * Cette fonction permet d'afficher les détails d'une opération de prestation et de les pré-remplir dans un formulaire de mise à jour.
   * @param { Object } operation - L'objet représentant l'opération de prestation à mettre à jour.
   */
  const handleShowUpdate = (operation) => {
    setSelectPrestataire(operation.provider_id);
    setSelectOperation(operation.operation_type_id.toString());
    setSelectOffre(
      state.operationsType
        .filter((elt) => elt.id === operation.operation_type_id)[0]
        .operation_descriptions.filter(
          (opeDesc) => opeDesc.name === operation.description
        )[0]
        ? state.operationsType
            .filter((elt) => elt.id === operation.operation_type_id)[0]
            .operation_descriptions.filter(
              (opeDesc) => opeDesc.name === operation.description
            )[0].id
        : "autre"
    );
    setCommentOperation(operation.comment);

    setAnimationsOperation(operation.animations);

    setDescriptionOtherOffer(
      state.operationsType
        .filter((elt) => elt.id === operation.operation_type_id)[0]
        .operation_descriptions.filter(
          (opeDesc) => opeDesc.name === operation.description
        )[0]
        ? ""
        : operation.description
    );
    setMonthOne(operation.month_1.toString());
    setMonthTwo(operation.month_2 ? operation.month_2.toString() : "");
    setMonthThree(operation.month_3 ? operation.month_3.toString() : "");
    handleUpdateComTool(operation.operation_com_tool);
    handleUpdateMerchandising(operation.operation_plv_value);
    setOperationId(operation.id);
    setShowUpdateOperation(true);
  };

  const handleClose = () => {
    setSelectPrestataire("");
    setErrorMessageMonths("");
    setOperationId("");
    setSelectOperation("");
    setSelectOffre("");
    setCommentOperation("");
    setDescriptionOtherOffer("");
    setMonthOne("");
    setMonthTwo("");
    setMonthThree("");
    setCheckedComTool(isCheckedComTool.fill(false));
    setCheckedMerchandising(isCheckedMerchandising.fill(false));
    setOperationMerchandisingData([]);
    setOperationCommunicationToolsData([]);
    setShowUpdateOperation(false);
    setShowAddOperation(false);
  };

  /**
   * Cette fonction met à jour les données des outils de communication associées à une opération existante. Elle prend en paramètre les données des outils de communication associées à l'opération en question, et met à jour les états isCheckedComTool et operationCommunicationToolsData en conséquence.
   * @param { Array } opeComTool - Les données des outils de communication associées à l'opération à mettre à jour.
   */
  const handleUpdateComTool = (opeComTool) => {
    var tab = isCheckedComTool.fill(false);
    opeComTool.forEach((e) =>
      state.listComTools.forEach((elt, i) =>
        elt.id === e.operation_com_tool_type_id ? (tab[i] = true) : ""
      )
    );
    var comToolsData = [];
    tab.forEach((elt, i) =>
      elt === true
        ? comToolsData.push({
            operation_com_tool_type_id: state.listComTools[i].id,
            operation_id: "",
            name: state.listComTools[i].name,
          })
        : ""
    );
    setCheckedComTool(tab);
    setOperationCommunicationToolsData(comToolsData);
  };

  /**
   * Cette fonction met à jour les données de PLV pour une opération spécifique.
   * @param { Array } opePlv - Tableau d'objets représentant les données de PLV pour l'opération.
   */
  const handleUpdateMerchandising = (opePlv) => {
    var tab = isCheckedMerchandising.fill(false);
    opePlv.forEach((e) =>
      state.listCustomerPlv.forEach((elt, i) =>
        elt.id === e.operation_plv_id ? (tab[i] = true) : ""
      )
    );
    var plvData = [];
    tab.forEach((elt, i) =>
      elt === true
        ? plvData.push({
            customer_id: state.dataSelectedClient.id,
            operation_plv_id: state.listCustomerPlv[i].id,
            quantity_max: state.listCustomerPlv[i].quantity_max,
            quantity: opePlv.filter(
              (elt) => elt.operation_plv_id === state.listCustomerPlv[i].id
            )[0]
              ? opePlv.filter(
                  (elt) => elt.operation_plv_id === state.listCustomerPlv[i].id
                )[0].quantity
              : 1,
            provider: opePlv.filter(
              (elt) => elt.operation_plv_id === state.listCustomerPlv[i].id
            )[0]
              ? opePlv.filter(
                  (elt) => elt.operation_plv_id === state.listCustomerPlv[i].id
                )[0].provider
              : 1,
            operation_id: "",
          })
        : ""
    );
    setOperationMerchandisingData(plvData);
    setCheckedMerchandising(tab);
  };

  /**
   * Cette fonction est appelée lorsqu'un élément de la liste des outils de communication est modifié.
   * Elle met à jour l'état de la case cochée correspondante et met également à jour les données des outils de communication pour la mise à jour de l'opération.
   * @param {number} position - La position de l'élément modifié dans la liste des outils de communication.
   */
  const handleOnChangeComTool = (position) => {
    const updatedCheckedState = isCheckedComTool.map((item, index) =>
      index === position ? !item : item
    );
    var comToolsData = [];
    updatedCheckedState.forEach((elt, i) =>
      elt === true
        ? comToolsData.push({
            operation_com_tool_type_id: state.listComTools[i].id,
            operation_id: "",
            name: state.listComTools[i].name,
          })
        : ""
    );
    setOperationCommunicationToolsData(comToolsData);
    setCheckedComTool(updatedCheckedState);
  };

  /**
   * Cette fonction gère le changement de l'état de la case à cocher pour les PLV et met à jour les données de l'opération en conséquence.
   * @param {Number} position - La position de la case à cocher qui a été modifiée.
   */
  const handleOnChangeMerchandising = (position) => {
    const updatedCheckedState = isCheckedMerchandising.map((item, index) =>
      index === position ? !item : item
    );
    var plvData = [];
    updatedCheckedState.forEach((elt, i) =>
      elt === true
        ? plvData.push({
            customer_id: state.dataSelectedClient.id,
            operation_plv_id: state.listCustomerPlv[i].id,
            quantity_max: state.listCustomerPlv[i].quantity_max,
            quantity: operationMerchandisingData.filter(
              (elt) => elt.operation_plv_id === state.listCustomerPlv[i].id
            )[0]
              ? operationMerchandisingData.filter(
                  (elt) => elt.operation_plv_id === state.listCustomerPlv[i].id
                )[0].quantity
              : 1,
            operation_id: "",
          })
        : ""
    );
    setOperationMerchandisingData(plvData);
    setCheckedMerchandising(updatedCheckedState);
  };

  /**
   * Cette fonction met à jour la quantité pour un type de PLV donné.
   * @param { Number } id - L'identifiant du type de PLV pour lequel la quantité doit être mise à jour.
   * @param { Number } qte - La nouvelle quantité à enregistrer.
   */
  const handleQuantityMerchandising = (id, qte) => {
    setOperationMerchandisingData((prevData) =>
      prevData.map((elt) => {
        if (elt.operation_plv_id === id) {
          return { ...elt, quantity: qte };
        } else {
          return elt;
        }
      })
    );
  };

  /**
   * Cette fonction récupère le nombre total d'opérations pour un client donné, en fonction des marques sélectionnées et de l'année en cours.
   * Les données sont récupérées via une requête API et stockées dans le store via le dispatch d'une action.
   */
  const getTotalNumberOfOperationByCustomer = async () => {
    var brands = [];
    JSON.parse(localStorage.getItem("currentBrands")).map((brand) =>
      brands.push(brand.value)
    );
    ApiService.request(
      {},
      `numbers-of-operations-by-brands-customer-year/${brands}/${
        state.dataSelectedClient.id
      }/${JSON.parse(localStorage.getItem("currentYear")).value}`,
      "get"
    )
      .then(function (response) {
        //console.log(response.data);
        dispatch({
          type: "SET_TOTALNUMBEROFCUSTOMEROPERATIONS",
          payload: response.data,
        });
      })
      .catch(function (error) {
        console.log(error);
        if (error.response.data.message === "Unauthenticated.") {
          localStorage.clear();
          dispatch({ type: "SET_LOGOUT", payload: false });
        }
      });
  };

  /**
   * Cette fonction récupère toutes les opérations en appelant l'API avec les filtres de marque, client et année enregistrés dans le local storage.
   * Elle met également à jour le nombre total d'opérations pour le client sélectionné.
   * Enfin, elle filtre les opérations en fonction du mois sélectionné et les stocke dans le state global de l'application.
   */
  const getAllOperations = async () => {
    var brands = [];
    JSON.parse(localStorage.getItem("currentBrands")).map((brand) =>
      brands.push(brand.value)
    );
    dispatch({ type: "SET_LOADER", payload: true });
    ApiService.request(
      {},
      `operations-by-brands-customer-year/${brands}/${
        state.dataSelectedClient.id
      }/${JSON.parse(localStorage.getItem("currentYear")).value}`,
      "get"
    )
      .then(function (response) {
        getTotalNumberOfOperationByCustomer();
        filterByMonth(filterMonth, response.data);
        //console.log(response.data, "All operations");
        dispatch({ type: "SET_LOADER", payload: false });
      })
      .catch(function (error) {
        // manque un message quand c'est une error
        console.log(error);
        dispatch({ type: "SET_LOADER", payload: false });
      });
  };

  /**
   * Cette fonction ajoute une nouvelle opération avec les informations saisies par l'utilisateur dans le formulaire correspondant.
   * @param { Object } e - L'événement déclencheur de l'ajout de l'opération.
   * @param { String } selectOperation - L'ID de l'opération sélectionnée.
   * @param { String } monthOne - Le nombre de jours pour la première période.
   * @param { String } monthTwo - Le nombre de jours pour la deuxième période.
   * @param { String } monthThree - Le nombre de jours pour la troisième période.
   * @param { String } commentOperation - Le commentaire pour l'opération.
   * @param { String } selectOffre - L'ID de l'offre sélectionnée.
   * @param { String } descriptionOtherOffer - La description de l'offre personnalisée.
   * @param { Array } operationMerchandisingData - Les données de merchandising pour l'opération.
   * @param { Array } operationCommunicationToolsData - Les données d'outils de communication pour l'opération.
   * @param { String } selectPrestataire - L'ID du prestataire sélectionné.
   * @param { Number } year_id - L'année à laquelle se rattacher.
   */
  const addOperation = async (e) => {
    e.preventDefault();
    dispatch({ type: "SET_LOADER", payload: true });
    ApiService.request(
      {
        brand_id: state.operationsType.filter(
          (e) => e.id.toString() === selectOperation
        )[0].brand_id,
        year_id: state.operationsType.filter(
          (e) => e.id.toString() === selectOperation
        )[0].year_id,
        customer_id: state.dataSelectedClient.id,
        operation_type_id: selectOperation,
        month_1: monthOne,
        month_2: monthTwo,
        month_3: monthThree,
        comment: commentOperation,
        description:
          selectOffre === "autre"
            ? descriptionOtherOffer
            : state.operationsType
                .filter((elt) => elt.id.toString() === selectOperation)[0]
                .operation_descriptions.filter(
                  (elt) => elt.id.toString() === selectOffre
                )[0].name,
        operation_merchandising_data: operationMerchandisingData,
        operation_communication_tools_data: operationCommunicationToolsData,
        provider_id: selectPrestataire,
      },
      "operations",
      "post"
    )
      .then(function (response) {
        dispatch({
          type: "SET_OPERATIONS",
          payload: response.data,
        });
        handleClose();
        dispatch({ type: "SET_LOADER", payload: false });
        getAllOperations();
      })
      .catch(function (error) {
        dispatch({ type: "SET_LOADER", payload: false });
        console.log(error);
        if (
          error.response.data.message.includes(
            "quota d'opérations maximales (6) pour ce client, cette marque et cette année"
          )
        ) {
          console.log(error.response.data.message);
          setErrorMessageMonths(error.response.data.message);
        }
        if (
          error.response.data.message.includes(
            "Une opération du même nom avec la même description existe déjà pour ce mois et cette marque."
          )
        ) {
          console.log(error.response.data.message);
          setErrorMessageMonths(error.response.data.message);
        }
        
        if (
          error.response.data.message.includes(
            "Seulement 2 opérations du même nom sont autorisées par mois et par marque."
          )
        ) {
          console.log(error.response.data.message);
          setErrorMessageMonths(error.response.data.message);
        }

        if (error.response.data.message === "Unauthenticated.") {
          localStorage.clear();
          dispatch({ type: "SET_LOGOUT", payload: false });
        }
      });
  };

  /**
   * Cette fonction met à jour une opération existante dans la base de données.
   * @param { Object } e - L'événement déclencheur de la fonction.
   * @param { String } selectOperation - L'ID de l'opération sélectionnée.
   * @param { String } monthOne - Le nombre de jours pour la première période.
   * @param { String } monthTwo - Le nombre de jours pour la deuxième période.
   * @param { String } monthThree - Le nombre de jours pour la troisième période.
   * @param { String } commentOperation - Le commentaire pour l'opération.
   * @param { String } selectOffre - L'ID de l'offre sélectionnée.
   * @param { String } descriptionOtherOffer - La description de l'offre personnalisée.
   * @param { Array } operationMerchandisingData - Les données de merchandising pour l'opération.
   * @param { Array } operationCommunicationToolsData - Les données d'outils de communication pour l'opération.
   * @param { String } selectPrestataire - L'ID du prestataire sélectionné.
   * @param { Number } year_id - L'année à laquelle se rattacher.
   * @param { Number } operationId - L'id de l'opération à mettre à jour.
   */
  const updateOperation = async (e) => {
    e.preventDefault();
    dispatch({ type: "SET_LOADER", payload: true });
    console.log(selectOffre, "selectOffre");
    ApiService.request(
      {
        brand_id: state.operationsType.filter(
          (e) => e.id.toString() === selectOperation
        )[0].brand_id,
        year_id: state.operationsType.filter(
          (e) => e.id.toString() === selectOperation
        )[0].year_id,
        customer_id: state.dataSelectedClient.id,
        operation_type_id: selectOperation,
        month_1: monthOne,
        month_2: monthTwo,
        month_3: monthThree,
        comment: commentOperation,
        description:
          selectOffre === "autre"
            ? descriptionOtherOffer
            : state.operationsType
                .filter((elt) => elt.id.toString() === selectOperation)[0]
                .operation_descriptions.filter(
                  (elt) => Number(elt.id) === Number(selectOffre)
                )[0].name,
        operation_merchandising_data: operationMerchandisingData,
        operation_communication_tools_data: operationCommunicationToolsData,
        provider_id: selectPrestataire,
      },
      "operations/" + operationId,
      "put"
    )
      .then(function (response) {
        dispatch({
          type: "SET_OPERATIONS",
          payload: response.data,
        });
        handleClose();
        dispatch({ type: "SET_LOADER", payload: false });
        getAllOperations();
      })
      .catch(function (error) {
        dispatch({ type: "SET_LOADER", payload: false });
        console.log(error);
        if (
          error.response.data.message.includes(
            "quota d'opérations maximales (6) pour ce client, cette marque et cette année"
          )
        ) {
          console.log(error.response.data.message);
          setErrorMessageMonths(error.response.data.message);
        }
        if (error.response.data.message === "Unauthenticated.") {
          localStorage.clear();
          dispatch({ type: "SET_LOGOUT", payload: false });
        }
      });
  };

  /**
   * Cette fonction supprime une opération à partir de son identifiant opeId, après confirmation de l'utilisateur. Si la suppression est effectuée avec succès, elle appelle la fonction getAllOperations() pour mettre à jour l'affichage des opérations.
   * @param { Number } opeId - L'identifiant de l'opération à supprimer.
   */
  const deleteOperation = async (opeId) => {
    if (
      window.confirm(
        "Voulez vous vraiment supprimer cette opération ? Cela est définitif."
      )
    ) {
      ApiService.request({}, "operations/" + opeId, "delete")
        .then(function () {
          getAllOperations();
        })
        .catch(function (error) {
          console.log(error);
          if (error.response.data.message === "Unauthenticated.") {
            localStorage.clear();
            dispatch({ type: "SET_LOGOUT", payload: false });
          }
        });
    }
  };

  /**
   * Cette fonction prend en entrée un nombre représentant un mois et retourne le nom complet du mois correspondant en français.
   * @param {Number} month - Le nombre représentant le mois (1 pour Janvier, 2 pour Février, etc.)
   * @returns {String} - Le nom complet du mois en français.
   */
  const getNameMonth = (month) => {
    var monthName = "";
    switch (month.toString()) {
      case "1":
        monthName = "Janvier";
        break;
      case "2":
        monthName = "Février";
        break;
      case "3":
        monthName = "Mars";
        break;
      case "4":
        monthName = "Avril";
        break;
      case "5":
        monthName = "Mai";
        break;
      case "6":
        monthName = "Juin";
        break;
      case "7":
        monthName = "Juillet";
        break;
      case "8":
        monthName = "Août";
        break;
      case "9":
        monthName = "Septembre";
        break;
      case "10":
        monthName = "Octobre";
        break;
      case "11":
        monthName = "Novembre";
        break;
      case "12":
        monthName = "Décembre";
        break;
      default:
        monthName = "";
    }
    return monthName;
  };

  /**
   * Cette fonction récupère tous les types d'opérations disponibles pour la marque et l'année du client en cours.
   */
  const getAllOperationsType = async () => {
    var brands = [];
    JSON.parse(localStorage.getItem("currentBrands")).map((brand) =>
      brands.push(brand.value)
    );
    dispatch({ type: "SET_LOADER", payload: true });
    ApiService.request(
      {},
      `operation-types-by-brands-year/${brands}/${
        JSON.parse(localStorage.getItem("currentYear")).value
      }`,
      "get"
    )
      .then(function (response) {
        dispatch({ type: "SET_LOADER", payload: false });
        const operationsType = response.data;
        dispatch({ type: "SET_OPERATIONSTYPE", payload: operationsType });
      })
      .catch(function (error) {
        // manque un message quand c'est une error
        console.log(error);
        dispatch({ type: "SET_LOADER", payload: false });
      });
  };

  /**
   * Cette fonction récupère la liste des outils de communication pour une année donnée et les stocke dans le state de l'application.
   * Elle utilise l'API pour effectuer une requête GET et attend une réponse au format JSON.
   * Si la requête est réussie, elle stocke la liste des outils de communication dans le state et initialise un tableau de booléens pour indiquer si chaque outil est sélectionné ou non.
   * Si la requête échoue, elle affiche une erreur dans la console et vérifie si l'utilisateur est authentifié avant de déclencher un logout.
   * @returns { Void }
   */
  const getComTools = async () => {
    dispatch({ type: "SET_LOADER", payload: true });
    ApiService.request(
      {},
      `operation-com-tool-types-by-year/${state.currentYear.value}`,
      "get"
    )
      .then(function (response) {
        dispatch({
          type: "SET_LISTCOMTOOLS",
          payload: response.data,
        });
        setCheckedComTool(Array(response.data.length).fill(false));
        dispatch({ type: "SET_LOADER", payload: false });
      })
      .catch(function (error) {
        // manque un message quand c'est une error
        dispatch({ type: "SET_LOADER", payload: false });
        console.log(error);
        if (error.response.data.message === "Unauthenticated.") {
          localStorage.clear();
          dispatch({ type: "SET_LOGOUT", payload: false });
        }
      });
  };

  /**
   * Cette fonction récupère la liste de tous les prestataires pour l'année en cours et met à jour la liste des prestataires dans le state global de l'application.
   */
  const getAllPrestataires = async () => {
    dispatch({ type: "SET_LOADER", payload: true });
    try {
      ApiService.request(
        {},
        `providers-by-year/${state.currentYear.value}`,
        "get"
      )
        .then(function (response) {
          dispatch({ type: "SET_LISTPRESTATAIRES", payload: response.data });
          //console.log(response.data);
          dispatch({ type: "SET_LOADER", payload: false });
        })
        .catch(function (error) {
          dispatch({ type: "SET_LOADER", payload: false });
          if (error.response.data.message === "Unauthenticated.") {
            localStorage.clear();
            dispatch({ type: "SET_LOGOUT", payload: false });
          }
        });
    } catch (error) {
      dispatch({ type: "SET_LOADER", payload: false });
      console.log(error.message);
    }
  };

  /**
   * Cette fonction récupère la liste des PLV pour un client donné, pour l'année en cours. Elle utilise l'API pour faire une requête GET et récupérer les données, puis dispatche l'action "SET_LISTCUSTOMERPLV" pour mettre à jour le state. Elle initialise également un tableau de booleans pour stocker l'état de la sélection des PLV.
   * @param {Number} customerId - L'identifiant du client pour lequel on souhaite récupérer la liste des PLV.
   */
  const getCustomerPlv = async (customerId) => {
    dispatch({ type: "SET_LOADER", payload: true });
    ApiService.request(
      {},
      `operation-plvs-by-customer-year/${customerId}/${
        JSON.parse(localStorage.getItem("currentYear")).value
      }`,
      "get"
    )
      .then(function (response) {
        dispatch({
          type: "SET_LISTCUSTOMERPLV",
          payload: response.data,
        });
        setCheckedMerchandising(Array(response.data.length).fill(false));
        dispatch({ type: "SET_LOADER", payload: false });
      })
      .catch(function (error) {
        dispatch({ type: "SET_LOADER", payload: false });
        console.log(error);
        if (error.response.data.message === "Unauthenticated.") {
          localStorage.clear();
          dispatch({ type: "SET_LOGOUT", payload: false });
        }
      });
  };

  /**
   * Cette fonction filtre les opérations par mois en fonction de la valeur sélectionnée dans le menu déroulant.
   * @param { Object } e - L'événement déclenché par l'utilisateur.
   * @param { Array } opeData - Les données des opérations. Par défaut, il s'agit des données stockées dans l'état global de l'application.
   */
  const filterByMonth = (e, opeData = state.operations) => {
    const data = [];
    setFilterMonth(e);
    if (e.value === 0) {
      dispatch({ type: "SET_OPERATIONS", payload: opeData });
    } else {
      opeData.forEach((elt) =>
        elt.month_1 === e.value ||
        elt.month_2 === e.value ||
        elt.month_3 === e.value
          ? data.push(elt)
          : ""
      );
      dispatch({ type: "SET_OPERATIONS", payload: data });
    }
  };

  React.useEffect(() => {
    if (state.dataSelectedClient && state.dataSelectedClient.id) {
      if (state.currentBrands.length > 0) {
        getAllOperationsType();
        getComTools();
        getAllPrestataires();
        getCustomerPlv(state.dataSelectedClient.id);
        getAllOperations();
      } else {
        dispatch({ type: "SET_OPERATIONS", payload: [] });
      }
    }
  }, [
    state.dataSelectedClient,
    state.currentYear,
    state.currentBrands,
    filterMonth,
  ]);

  return (
    <>
      <div className="row">
        <div className="col-md-10">
          <h1>
            Operations
            {(parseInt(localStorage.getItem("user_role")) !== 5 &&
              parseInt(localStorage.getItem("user_role")) !== 6) && (
              <Dropdown className="d-inline-block">
                <Dropdown.Toggle>
                  <MoreVertIcon />
                </Dropdown.Toggle>

                <Dropdown.Menu>
                  <Dropdown.Item
                    onClick={handleShowAdd}
                    disabled={
                      state.currentBrands.length === 0
                        ? true
                        : state.dataSelectedClient &&
                          state.dataSelectedClient.id
                        ? false
                        : true
                    }
                  >
                    <AddCircleOutlineOutlinedIcon /> Ajouter
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            )}
          </h1>
        </div>
        <div className="col-md-2">
          <Select
            placeholder="Mois.."
            required
            isMulti={false}
            name="month"
            value={filterMonth}
            onChange={(e) => filterByMonth(e)}
            options={state.allMonth}
            className="bg-blue-light black border-white"
          />
        </div>
      </div>

      {showAddOperation && (
        <OperationModalRegisterOrUpdate

          animationsOperation={animationsOperation}

          controlFormId={"addOperation"}
          showOperation={showAddOperation}
          addOrUpdateOperation={addOperation}
          selectOperation={selectOperation}
          setSelectOperation={setSelectOperation}
          monthOne={monthOne}
          setMonthOne={setMonthOne}
          monthTwo={monthTwo}
          setMonthTwo={setMonthTwo}
          monthThree={monthThree}
          setMonthThree={setMonthThree}
          selectOffre={selectOffre}
          setSelectOffre={setSelectOffre}
          descriptionOtherOffer={descriptionOtherOffer}
          setDescriptionOtherOffer={setDescriptionOtherOffer}
          isCheckedComTool={isCheckedComTool}
          handleOnChangeComTool={handleOnChangeComTool}
          isCheckedMerchandising={isCheckedMerchandising}
          handleOnChangeMerchandising={handleOnChangeMerchandising}
          operationMerchandisingData={operationMerchandisingData}
          operationCommunicationToolsData={operationCommunicationToolsData}
          handleQuantityMerchandising={handleQuantityMerchandising}
          commentOperation={commentOperation}
          setCommentOperation={setCommentOperation}
          handleClose={handleClose}
          errorMessageMonths={errorMessageMonths}
          listPlvs={state.listCustomerPlv}
          selectPrestataire={selectPrestataire}
          setSelectPrestataire={setSelectPrestataire}
        />
      )}
      {showUpdateOperation && (
        <OperationModalRegisterOrUpdate

          animationsOperation={animationsOperation}

          controlFormId={"updateOperation"}
          showOperation={showUpdateOperation}
          addOrUpdateOperation={updateOperation}
          selectOperation={selectOperation}
          setSelectOperation={setSelectOperation}
          monthOne={monthOne}
          setMonthOne={setMonthOne}
          monthTwo={monthTwo}
          setMonthTwo={setMonthTwo}
          monthThree={monthThree}
          setMonthThree={setMonthThree}
          selectOffre={selectOffre}
          setSelectOffre={setSelectOffre}
          descriptionOtherOffer={descriptionOtherOffer}
          setDescriptionOtherOffer={setDescriptionOtherOffer}
          isCheckedComTool={isCheckedComTool}
          handleOnChangeComTool={handleOnChangeComTool}
          isCheckedMerchandising={isCheckedMerchandising}
          handleOnChangeMerchandising={handleOnChangeMerchandising}
          operationMerchandisingData={operationMerchandisingData}
          operationCommunicationToolsData={operationCommunicationToolsData}
          handleQuantityMerchandising={handleQuantityMerchandising}
          commentOperation={commentOperation}
          setCommentOperation={setCommentOperation}
          handleClose={handleClose}
          errorMessageMonths={errorMessageMonths}
          listPlvs={state.listCustomerPlv}
          selectPrestataire={selectPrestataire}
          setSelectPrestataire={setSelectPrestataire}
        />
      )}
      {state.currentBrands &&
      state.currentBrands.length > 0 &&
      state.dataSelectedClient &&
      state.dataSelectedClient.id ? (
        <>
          {state.operations && !state.loader && state.operations.length > 0 ? (
            state.operations.map((operation, i) => (
              <AccordionOperations
                key={i}
                operation={operation}
                keyAccordion={i}
                handleShowUpdate={handleShowUpdate}
                getNameMonth={getNameMonth}
                deleteOperation={deleteOperation}
              />
            ))
          ) : state.loader ? (
            <div className="text-center pt-5">
              <Spinner animation="border" role="status"></Spinner>
            </div>
          ) : (
            <Card className="text-center">
              <Card.Body>
                <Alert variant="info" className="m-0">
                  La liste est vide.
                </Alert>
              </Card.Body>
            </Card>
          )}
        </>
      ) : state.dataSelectedClient && state.dataSelectedClient.id ? (
        <Card className="text-center">
          <Card.Body>
            <Alert variant="danger" className="m-0">
              Veuillez sélectionner au moins une marque.
            </Alert>
          </Card.Body>
        </Card>
      ) : (
        <Card className="text-center">
          <Card.Body>
            <Alert variant="danger" className="m-0">
              Veuillez sélectionner un client.
            </Alert>
          </Card.Body>
        </Card>
      )}
    </>
  );
};

export default OperationsTrade;
